/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCloudScreenPencil = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M7 11.713h10v9.76H7zm2 1.952v.76h6v-.76zm6 2.711H9v3.145h6z" />
        <path d="M15 3.904a4.972 4.972 0 0 0-4.643 3.118A4.95 4.95 0 0 0 9 6.832c-2.761 0-5 2.186-5 4.88v.48c-1.465 1.13-2.207 2.652-2.583 3.877a9.867 9.867 0 0 0-.41 2.254 5.63 5.63 0 0 0-.007.2v.998h4V17.57H3.107c.049-.278.121-.599.226-.94.337-1.097.986-2.324 2.222-3.128l.445-.29v-1.498c0-1.617 1.343-2.928 3-2.928.55 0 1.068.156 1.528.425l1.343.785.165-1.519C12.198 7 13.461 5.856 15 5.856c1.657 0 3 1.312 3 2.929 0 .005 0 .022-.007.074l-.007.048-.006.043-.015.13-.071.712.673.28C20 10.67 21 12.055 21 13.666c0 .928-.402 1.94-1.034 2.72-.495.61-1.044.979-1.533 1.12l1.508 1.47a5.784 5.784 0 0 0 1.593-1.379c.868-1.07 1.466-2.498 1.466-3.931 0-2.171-1.21-4.062-3.004-5.074-.104-2.605-2.301-4.687-4.996-4.687z" />
      </g>
    </g>
  </Icon>
);
export { SvgCloudScreenPencil as CloudScreenPencil };
